import * as React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { ENABLE_DIALOG_ERROR_STATUS_CODES } from 'api/utils'

import { deleteWorker, selectWorkersStatus } from 'slices/workersSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  workerId: number
  onSuccess: () => void
  onCancel: () => void
}

const WorkerDelete: React.FC<Props> = ({ isOpen, workerId, onSuccess, onCancel }) => {
  const [modalErrorMessage, setModalErrorMessage] = React.useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = React.useState(false)
  const { isRequesting, errorMessage } = useSelector(selectWorkersStatus, shallowEqual)
  const dispatch = useDispatch()

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    setSubmitted(false)
    onCancel()
  }

  React.useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else if (!ENABLE_DIALOG_ERROR_STATUS_CODES.includes(errorMessage)) {
      setModalErrorMessage('削除できませんでした。')
    }
    setSubmitted(false)
  }, [onSuccess, submitted, isRequesting, errorMessage, dispatch])

  const handleDeleteClick = () => {
    setSubmitted(true)
    dispatch(deleteWorker(workerId))
  }

  return (
    <CustomModal
      isOpen={isOpen}
      title="メンバーの削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">このメンバーを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default WorkerDelete
